






















import {
  Component,
  Prop,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";


@Component({
  components: {}
})
export default class UmbInvestmentAccountPage extends mixins(ErrorsMixin) {

  formatCurrency = formatCurrency;
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();

  @Prop({ required: false }) username: string;

  @Prop({ required: false }) partnerId: number;

  mounted (): void {
    this.investmentDailyBalanceStore.loadCurrentDailyBalance({ username: this.username, partnerId: this.partnerId });
  }

  get investmentBalance (): number {
    return this.investmentDailyBalanceStore.umbCurrentBalanceOrNull
        ? this.investmentDailyBalanceStore.umbCurrentBalanceOrNull.balance
        : this.investmentDailyBalanceStore.investmentBalanceOnFileAmount as number;
  }

  get investmentBalanceDate (): string {
    return moment(this.investmentDailyBalanceStore.umbCurrentBalanceOrNull
        ? this.investmentDailyBalanceStore.umbCurrentBalanceOrNull.date
        : this.investmentDailyBalanceStore.investmentBalanceOnFileDate as string).format("MMM DD");
  }

  get isLoaded (): boolean {
    return this.investmentDailyBalanceStore.currentBalanceIsLoaded;
  }

  get titleCopy (): string {
    if (this.isLoaded) {
      return "Investment Balance";
    }

    return "Loading...";
  }
}
